import { takeLatest, put } from 'redux-saga/effects'
import {
  getSportsList,
  getCountriesList,
  getMatchesList,
  getMarketsList,
  getTournamentsList,
  updateStatus
} from '../../utils/apiCalls'
import { toast } from '../../components/Toast'

import {
  getSportsListStart,
  getSportsListSuccess,
  getSportsListFailure,
  getCountriesListStart,
  getCountriesListSuccess,
  getCountriesListFailure,
  getMatchesListStart,
  getMatchesListSuccess,
  getMatchesListFailure,
  getMarketsListStart,
  getMarketsListSuccess,
  getMarketsListFailure,
  getTournamentsListStart,
  getTournamentsListSuccess,
  getTournamentsListFailure,
  updateStatusStart,
  updateStatusSuccess,
  updateStatusFailure
} from '../redux-slices/sportsBook'

export default function* sportsBookWatcher() {
  yield takeLatest(getSportsListStart.type, getSportsListWorker)
  yield takeLatest(getCountriesListStart.type, getCountriesListWorker)
  yield takeLatest(getMatchesListStart.type, getMatchesListWorker)
  yield takeLatest(getMarketsListStart.type, getMarketsListWorker)
  yield takeLatest(getTournamentsListStart.type, getTournamentsListWorker)
  yield takeLatest(updateStatusStart.type, updateStatusWorker)
}



function* getSportsListWorker(action) {
  try {
    const { data } = yield getSportsList(action.payload)
    yield put(getSportsListSuccess(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getSportsListFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getCountriesListWorker(action) {
  try {
    const { data } = yield getCountriesList(action.payload)
    yield put(getCountriesListSuccess(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getCountriesListFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getMatchesListWorker(action) {
  try {
    const { data } = yield getMatchesList(action.payload)
    yield put(getMatchesListSuccess(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getMatchesListFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getMarketsListWorker(action) {
  try {
    const { data } = yield getMarketsList(action.payload)
    yield put(getMarketsListSuccess(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getMarketsListFailure(e?.response?.data?.errors[0]?.description))
  }
}
function* getTournamentsListWorker(action) {
  try {
    const { data } = yield getTournamentsList(action.payload)
    yield put(getTournamentsListSuccess(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getTournamentsListFailure(e?.response?.data?.errors[0]?.description))
  }
}
function* updateStatusWorker(action) {
  try {
    const { data } = yield updateStatus(action.payload)
    const {
      search, limit, pageNo, code
    } = action.payload
    yield put(updateStatusSuccess(data))
    if (code === 'SPORTCONTRY') {
      yield put(getCountriesListStart({
        limit,
        pageNo,
        search
      }))
    } else if (code === 'SPORTS'){
      yield put(getSportsListStart({
        limit,
        pageNo,
        search
      }))
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(updateStatusFailure(e?.response?.data?.errors[0]?.description))
  }
}